import { render, staticRenderFns } from "./Slide.vue?vue&type=template&id=78fe4a38&shadow"
import script from "./Slide.vue?vue&type=script&lang=ts&shadow"
export * from "./Slide.vue?vue&type=script&lang=ts&shadow"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

component.options.__file = "Slide.vue"
export default component.exports